import './FilterNewsButton.css';

function FilterNewsButton({ buttonText, onClick, activeButton }) {
  const isActive = buttonText === activeButton;

  return (
    <button
      type="button"
      onClick={() => onClick(buttonText)}
      className={`filterNewsButton ${isActive ? 'filterNewsButton_active' : ''}`}
    >
      {buttonText}
    </button>
  );
}
export default FilterNewsButton;
